/**
 * This function is duplicated from conversations-visitor-ui/static/js/post-message/postMessageToParent.ts
 *
 * Reason: Cross-package imports between conversations-visitor-message-history and conversations-visitor-ui
 * are not feasible due to dependency architecture constraints.
 */

export const postMessageToParent = (type, data) => {
  try {
    window.parent.postMessage(JSON.stringify({
      type,
      data
    }), '*');
    return {
      type,
      data
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error posting message to parent', e);
  }
};